function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 6.11701C0 2.73868 2.73868 0 6.11701 0H67.2871C70.6655 0 73.4041 2.73868 73.4041 6.11701V67.2871C73.4041 70.6655 70.6655 73.4041 67.2871 73.4041H6.11701C2.73868 73.4041 0 70.6655 0 67.2871V6.11701Z",
    fill: "white",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 6.11701C0 2.73868 2.73868 0 6.11701 0H67.2871C70.6655 0 73.4041 2.73868 73.4041 6.11701V67.2871C73.4041 70.6655 70.6655 73.4041 67.2871 73.4041H6.11701C2.73868 73.4041 0 70.6655 0 67.2871V6.11701Z",
    fill: "white",
    fillOpacity: 0.7,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 94.4149C0 91.0366 2.73868 88.2979 6.11701 88.2979H67.2871C70.6655 88.2979 73.4041 91.0366 73.4041 94.4149V155.585C73.4041 158.963 70.6655 161.702 67.2871 161.702H6.11701C2.73868 161.702 0 158.963 0 155.585V94.4149Z",
    fill: "white",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 94.4149C0 91.0366 2.73868 88.2979 6.11701 88.2979H67.2871C70.6655 88.2979 73.4041 91.0366 73.4041 94.4149V155.585C73.4041 158.963 70.6655 161.702 67.2871 161.702H6.11701C2.73868 161.702 0 158.963 0 155.585V94.4149Z",
    fill: "white",
    fillOpacity: 0.7,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 182.713C0 179.335 2.73868 176.596 6.11701 176.596H67.2871C70.6655 176.596 73.4041 179.335 73.4041 182.713V243.883C73.4041 247.261 70.6655 250 67.2871 250H6.11701C2.73868 250 0 247.261 0 243.883V182.713Z",
    fill: "white",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 182.713C0 179.335 2.73868 176.596 6.11701 176.596H67.2871C70.6655 176.596 73.4041 179.335 73.4041 182.713V243.883C73.4041 247.261 70.6655 250 67.2871 250H6.11701C2.73868 250 0 247.261 0 243.883V182.713Z",
    fill: "white",
    fillOpacity: 0.7,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2979 6.11701C88.2979 2.73868 91.0366 0 94.4149 0H155.585C158.963 0 161.702 2.73868 161.702 6.11701V67.2871C161.702 70.6655 158.963 73.4041 155.585 73.4041H94.4149C91.0366 73.4041 88.2979 70.6655 88.2979 67.2871V6.11701Z",
    fill: "white",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2979 6.11701C88.2979 2.73868 91.0366 0 94.4149 0H155.585C158.963 0 161.702 2.73868 161.702 6.11701V67.2871C161.702 70.6655 158.963 73.4041 155.585 73.4041H94.4149C91.0366 73.4041 88.2979 70.6655 88.2979 67.2871V6.11701Z",
    fill: "white",
    fillOpacity: 0.7,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2979 94.4149C88.2979 91.0366 91.0366 88.2979 94.4149 88.2979H155.585C158.963 88.2979 161.702 91.0366 161.702 94.4149V155.585C161.702 158.963 158.963 161.702 155.585 161.702H94.4149C91.0366 161.702 88.2979 158.963 88.2979 155.585V94.4149Z",
    fill: "white",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2979 94.4149C88.2979 91.0366 91.0366 88.2979 94.4149 88.2979H155.585C158.963 88.2979 161.702 91.0366 161.702 94.4149V155.585C161.702 158.963 158.963 161.702 155.585 161.702H94.4149C91.0366 161.702 88.2979 158.963 88.2979 155.585V94.4149Z",
    fill: "white",
    fillOpacity: 0.7,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2979 182.713C88.2979 179.335 91.0366 176.596 94.4149 176.596H155.585C158.963 176.596 161.702 179.335 161.702 182.713V243.883C161.702 247.261 158.963 250 155.585 250H94.4149C91.0366 250 88.2979 247.261 88.2979 243.883V182.713Z",
    fill: "white",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2979 182.713C88.2979 179.335 91.0366 176.596 94.4149 176.596H155.585C158.963 176.596 161.702 179.335 161.702 182.713V243.883C161.702 247.261 158.963 250 155.585 250H94.4149C91.0366 250 88.2979 247.261 88.2979 243.883V182.713Z",
    fill: "white",
    fillOpacity: 0.7,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.596 6.11701C176.596 2.73868 179.335 0 182.713 0H243.883C247.261 0 250 2.73868 250 6.11701V67.2871C250 70.6655 247.261 73.4041 243.883 73.4041H182.713C179.335 73.4041 176.596 70.6655 176.596 67.2871V6.11701Z",
    fill: "white",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.596 6.11701C176.596 2.73868 179.335 0 182.713 0H243.883C247.261 0 250 2.73868 250 6.11701V67.2871C250 70.6655 247.261 73.4041 243.883 73.4041H182.713C179.335 73.4041 176.596 70.6655 176.596 67.2871V6.11701Z",
    fill: "white",
    fillOpacity: 0.7,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.596 94.4149C176.596 91.0366 179.335 88.2979 182.713 88.2979H243.883C247.261 88.2979 250 91.0366 250 94.4149V155.585C250 158.963 247.261 161.702 243.883 161.702H182.713C179.335 161.702 176.596 158.963 176.596 155.585V94.4149Z",
    fill: "white",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.596 94.4149C176.596 91.0366 179.335 88.2979 182.713 88.2979H243.883C247.261 88.2979 250 91.0366 250 94.4149V155.585C250 158.963 247.261 161.702 243.883 161.702H182.713C179.335 161.702 176.596 158.963 176.596 155.585V94.4149Z",
    fill: "white",
    fillOpacity: 0.7,
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.596 182.713C176.596 179.335 179.335 176.596 182.713 176.596H243.883C247.261 176.596 250 179.335 250 182.713V243.883C250 247.261 247.261 250 243.883 250H182.713C179.335 250 176.596 247.261 176.596 243.883V182.713Z",
    fill: "white",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.596 182.713C176.596 179.335 179.335 176.596 182.713 176.596H243.883C247.261 176.596 250 179.335 250 182.713V243.883C250 247.261 247.261 250 243.883 250H182.713C179.335 250 176.596 247.261 176.596 243.883V182.713Z",
    fill: "white",
    fillOpacity: 0.7,
    style: {
      mixBlendMode: "overlay"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector5);
export default __webpack_public_path__ + "static/media/Vector (5).bf7b11a5908ac5750e441b921fd0dc6c.svg";
export { ForwardRef as ReactComponent };